import styled, { css } from 'styled-components';
// cor de acento do detalhe = mesmo azul do botao "Detalhes" da tela de resultado
// (ThemeButton .button-select). Azul mais claro que o navy do header da campanha.
const DETAIL_ACCENT = '#1392EC';
const accentColor = () => DETAIL_ACCENT;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: #f2f2f2;
    font-family: 'Poppins';
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: #000;
    opacity: 0.8;

    margin: 0;
    padding: 0;
  `}
`;

export const Title3 = styled.h3`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 14px;
    color: #1e293b;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    margin: 0 0 12px;

    /* US-27: marcador vertical (Figma: 6px, pill, #1392EC) */
    &::before {
      content: '';
      flex: none;
      width: 6px;
      height: 24px;
      border-radius: 9999px;
      background-color: ${accentColor(theme)};
    }
  `}
`;

export const Descricao = styled.span`
  ${({ theme }) => css`
    display: block;
    color: #475569;
    font-size: 18px;
    line-height: 29px;
  `}
`;

/* US-27: inclusos / nao inclusos como topicos com bullets (Figma) */
export const BulletList = styled.ul`
  ${({ theme }) => css`
    margin: 0;
    padding-left: 18px;

    li {
      color: #475569;
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 8px;
    }
  `}
`;

export const CarouselContainer = styled.h1`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    margin: 0;
  `}
`;

export const Hero = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    margin: 16px 0 24px;
    border-radius: 12px;
    overflow: hidden;
  `}
`;

export const HeroOverlay = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 24px;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    color: #fff;
    pointer-events: none;
  `}
`;

export const HeroBack = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 32px;
    left: 32px;
    z-index: 2;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 9999px;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(6px);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    pointer-events: auto;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.35);
    }
  `}
`;

export const HeroBadge = styled.span`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: ${accentColor(theme)};
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 10px;
  `}
`;

export const HeroTitle = styled.h1`
  ${({ theme }) => css`
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    color: #fff;

    ${theme.breakpoints.down('xs')} {
      font-size: 20px;
    }
  `}
`;

export const HeroLocation = styled.span`
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-top: 6px;

  svg {
    margin-right: 4px;
  }
`;

export const Section = styled.div`
  margin-bottom: 28px;
`;

export const PolicyBox = styled.div`
  ${({ theme }) => css`
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-left: 4px solid ${accentColor(theme)};
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 28px;

    .free {
      display: flex;
      align-items: center;
      color: #2e7d32;
      font-weight: 600;
      font-size: 14px;
      margin: 4px 0 8px;

      svg {
        margin-right: 4px;
      }
    }
  `}
`;

export const LinksRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;

    .link-button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      text-decoration: none;
      border: 1px solid ${accentColor(theme)};
      color: ${accentColor(theme)};
      border-radius: 8px;
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 500;
      transition: background-color 0.2s;

      &:hover {
        background-color: ${accentColor(theme)};
        color: #fff;
      }
    }
  `}
`;

export const Sidebar = styled.div`
  ${({ theme }) => css`
    position: sticky;
    top: 24px;
    background-color: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 16px;
    padding: 33px;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 8px 10px -6px rgba(0, 0, 0, 0.1);

    .confirm-reservation {
      width: 100%;
      height: 60px;
      margin-top: 16px;
      border-radius: 12px;
      font-size: 18px;
      font-weight: 700;
      text-transform: none;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &:not(:disabled) {
        background-color: ${accentColor(theme)} !important;
        color: #fff !important;
      }

      svg {
        font-size: 20px;
      }
    }
  `}
`;

export const PriceLine = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: baseline;
    gap: 6px;

    .value {
      font-size: 28px;
      font-weight: 700;
      color: ${accentColor(theme)};
    }

    .per {
      font-size: 13px;
      color: #6b7280;
    }
  `}
`;

export const SidebarHint = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-top: 12px;
`;

/* US-28: bloco de preco "A PARTIR DE pts X /pessoa" (Figma) */
export const PriceBlock = styled.div`
  ${({ theme }) => css`
    .from-label {
      display: block;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.7px;
      color: #64748b;
      text-transform: uppercase;
      margin-bottom: 4px;
    }

    .price {
      display: flex;
      align-items: baseline;
      gap: 8px;

      .value {
        font-size: 36px;
        font-weight: 700;
        line-height: 40px;
        color: ${accentColor(theme)};
      }

      .per {
        font-size: 18px;
        color: #94a3b8;
      }
    }
  `}
`;

/* US-28: texto sob o botao Confirmar Reserva (Figma) */
export const Disclaimer = styled.p`
  font-size: 11px;
  color: #9ca3af;
  text-align: center;
  margin: 10px 0 0;
  line-height: 1.4;
`;

/* US-28: caixa de data #F6F7F8 com label + dropdown borderless (Figma) */
export const DateField = styled.div`
  ${({ theme }) => css`
    margin-top: 24px;
    background: #f6f7f8;
    border-radius: 12px;
    padding: 14px 16px;

    .field-label {
      display: block;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.3px;
      color: #64748b;
      text-transform: uppercase;
      margin-bottom: 4px;
    }

    /* MUI select dentro do box: sem borda/fundo */
    .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }
    .MuiOutlinedInput-root {
      background: transparent;
      box-shadow: none;
    }
    .MuiSelect-select {
      padding: 4px 0;
      font-size: 16px;
      font-weight: 500;
      color: #334155;
      background: transparent;
    }
    /* icone calendario (startAdornment) e chevron na cor do tema */
    .MuiInputAdornment-root svg,
    .MuiSelect-icon {
      color: ${accentColor(theme)};
    }
  `}
`;

/* US-28: linha Qtde Pessoas | Estoque (com icones) */
export const MetaRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 12px;
    margin-top: 16px;

    .meta {
      flex: 1;
      min-width: 0;
      background: #f6f7f8;
      border-radius: 12px;
      padding: 14px 16px;
    }

    .meta-label {
      display: block;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.3px;
      color: #64748b;
      text-transform: uppercase;
      margin-bottom: 6px;
    }

    .meta-value {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 500;
      color: #334155;

      svg {
        font-size: 22px;
        color: ${accentColor(theme)};
        flex: none;
      }

      input {
        width: 100%;
        min-width: 0;
        border: none;
        outline: none;
        font-family: 'Poppins';
        font-size: 16px;
        font-weight: 500;
        color: #334155;
        background: transparent;
      }

      /* estoque: icone + valor verde (Figma #10B981) */
      &.estoque {
        color: #10b981;
        svg {
          color: #10b981;
        }
      }

      &.soldout {
        color: #d32f2f;
        svg {
          color: #d32f2f;
        }
      }
    }
  `}
`;

export const EstoqueBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: ${({ soldout }) => (soldout ? '#d32f2f' : '#1f2937')};
  `}
`;

export const SecureBadge = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 58px;
    margin-top: 16px;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 12px;

    svg {
      color: ${accentColor(theme)};
      font-size: 20px;
    }

    strong {
      font-size: 14px;
      font-weight: 500;
      color: #64748b;
    }
  `}
`;

export const ExperienceName = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;

    padding: 30px;
    padding-bottom: 10px;
    padding-top: 10px;

    ${theme.breakpoints.down('md')} {
      padding: 0px;
    }

    span {
      width: 100%;
    }

    .location {
      display: flex;
      align-content: center;
      font-size: 12px;
      font-weight: 300;
      margin-top: 5px;
    }
  `}
`;

export const InformacoesUteis = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    padding: 30px;
    padding-top: 0;

    ${theme.breakpoints.down('md')} {
      padding: 0px;
    }

    span {
      width: 100%;
    }
  `}
`;

export const CheckInOut = styled.div`
  ${({ theme }) => css`
    width: 100%;
  `}
`;

export const Amenities = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;

  span {
    width: 100%;
    display: flex;
    svg {
      margin-right: 5px;
    }
  }

  .child {
    margin-left: 26px;
  }
`;

export const ValueInfos = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-top: 30px;
    flex-wrap: wrap;
    width: 100%;

    .choose-hotel {
      width: 100%;
    }
    div {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;

      .old-value {
        color: #000;
        opacity: 65%;
        font-size: 14px;
        width: unset;
        ${theme.breakpoints.down('xs')} {
          display: flex;
          justify-content: flex-end !important;
          width: 100%;
        }

        .value {
          text-decoration: line-through;
        }
      }

      .final-value {
        font-size: 26px;
        font-weight: 600;
        margin-left: 4px;
        width: unset;
        ${theme.breakpoints.down('xs')} {
          display: flex;
          justify-content: flex-end !important;
          width: 100%;
        }
      }
    }
  `}
`;

export const Personas = styled.div`
  ${({ theme }) => css`
    padding-top: 20px;
    display: flex;

    width: 100%;
    div {
      padding: 5px;
    }
  `}
`;

export const Fields = styled.div`
	${({ theme }) => css`
		padding-top: 20px;
		display: flex;

		width: 100%;
		div {
			padding: 5px;
		}
	`}
`;

/* Demanda 231 parte 3 — bloco do contador regressivo de liberacao de venda. */
export const SaleCountdown = styled.div`
	margin-bottom: 16px;
	padding: 12px 16px;
	border-radius: 8px;
	background: #f2f2f2;
	text-align: center;

	.countdown-label {
		display: block;
		font-size: 12px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		color: #666;
		margin-bottom: 6px;
	}

	.countdown-value {
		display: flex;
		justify-content: center;
		gap: 12px;
		font-size: 20px;
		font-weight: 700;
		color: ${({ theme }) => theme?.colors?.primary || '#1b2a5b'};
	}
`;
